import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-community/core';
import { Component, EventEmitter, OnDestroy, Output } from '@angular/core';
import { CdwButtonModule } from '@cdw-ae/common-ui-components-button';
import { CdwIconModule } from '@cdw-ae/common-ui-components-icon';
import { Subject, takeUntil } from 'rxjs';
import { CdwSearchGridComponentStore } from '../+component-state/cdw-search-grid-component.store';
import { GridActionNotificationService } from '../services/grid-action-notification.service';

@Component({
  selector: 'lib-delete-item-icon',
  templateUrl: './delete-item-icon.component.html',
  styleUrls: ['./delete-item-icon.component.scss'],
  imports: [CdwButtonModule, CdwIconModule],
})
export class DeleteItemIconComponent<T extends { id: string | number }>
  implements ICellRendererAngularComp, OnDestroy
{
  @Output() deleteIconClicked = new EventEmitter<string | number>();

    public useMatIcon = false;

  public customTextColor?: string;

  private rowId!: string | number;

  private gridComponentId?: string;

  private onDestroy$: Subject<void> = new Subject<void>();

  constructor(
    private readonly componentState: CdwSearchGridComponentStore<T>,
    private gridNotifications: GridActionNotificationService
  ) {}

  ngOnDestroy(): void {
    this.onDestroy$.next();
  }

  public agInit(params: ICellRendererParams<T>): void {
    this.componentState.componentId$
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((componentId) => {
        this.gridComponentId = componentId;
      });

    if (params.data?.id) {
      this.rowId = params.data.id;
    }

    // Get properties from grid context
    this.useMatIcon = params.context?.useMatIcon ?? false;
    this.customTextColor = params.context?.customTextColor;
  }

  // this method is needed to fulfill the ICellRendererAngularComp interface
  public refresh(): boolean {
    return false;
  }

  public onClick(event$: Event): void {
    this.deleteIconClicked.emit(this.rowId);
    event$.stopPropagation();

    // Notify via Subject - parent component handles the delete flow
    this.gridNotifications.notifyDeleteRow(this.rowId, this.gridComponentId);
  }
}